import { render } from "./RegenerateEmail.vue?vue&type=template&id=72e298b0"
import script from "./RegenerateEmail.vue?vue&type=script&lang=js"
export * from "./RegenerateEmail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/public/RegenerateEmail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "72e298b0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('72e298b0', __exports__)) {
    api.reload('72e298b0', __exports__)
  }
  
  module.hot.accept("./RegenerateEmail.vue?vue&type=template&id=72e298b0", () => {
    api.rerender('72e298b0', render)
  })

}


export default __exports__